<template>
 <transition appear>
  <section>
   
   <!-- <div id="img-container"> -->
    <img
      id="header-image"
      src="@/assets/images/header-image.png"
      alt="social media abuse image"
    />
    <!-- </div> -->
    

    <div id="header-container">
      <div id="header-text-box">
        <h1 id="headline">
          <span class="blue">Social Media Abuse</span> of Sports Stars
        </h1>
        <h2 id="sub-headline">Who Gets The Most Online Abuse?</h2>
        <div id="header-body-text">
          <span class="red">There are few topics that drive conversation like sport. </span> 
          While healthy debate is a good thing, the accessibility afforded by social media has opened up a pandoras 
          box of trolling and abusive messages aimed at athletes.<br><br>
          To showcase what elite athletes now have to live with, 
          the team at <a href="https://www.pickswise.com/" target="_blank">Pickswise</a> have analysed every single tweet sent to elite athletes in the sports of Football, 
          Basketball, Soccer, Tennis, Golf and Ice Hockey over the past 12 months.<br><br>
          Filter the interactive table below to sort by abusive tweet count, sport and name. To mark Pride month, we’ve created a tab of the athletes in receipt of the most LGBT-phobic abuse.

        </div>
        <h2 id="header-foot">Find Out Below</h2>
      </div>
    </div>
  </section>
  </transition>
</template>

<style lang="scss" scoped>

.v-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.v-enter-to {
  opacity: 1;
  transform: translate(0);
}

.v-enter-active {
  transition: all 1.0s ease-out;
}
section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: $blue;
  color: $white;

  @include respond(desktop-sm) {
    flex-direction: column;
  }
}

#header-image {
  width: 100%;
  max-width: 580px;
 

  @include respond(desktop-sm) {
    max-width: none;
    max-width: 700px;
    margin-left:none;
    margin-bottom:20px;
  }
}

#header-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;

  @include respond(desktop-sm) {
    margin-top: -60px;
  }
}

#header-text-box {
  max-width: 800px;
  padding: 20px;
  text-align: left;
  @include respond(desktop-sm) {
    text-align: center;
  }
}

#headline {
  font-family:BigShouldersDisplay, sans-serif;
  font-size: 60px;
  padding-top: 40px;
}

#sub-headline {
  font-size: 25px;
  color: $red;
  padding-top: 10px;
}

#header-body-text {
  font-size: 16px;
  color: $text-grey;
  padding-top: 40px;
  
   @include respond(desktop-sm) {
    text-align: left;
    // margin:10px;
  }
}

#header-foot {
  font-size: 25px;
  padding: 40px 0px 10px 0px;
}

.blue {
  color: $text-blue;
}

.red {
  color: $red;
}
</style>